<template>
  <v-container class="pa-0">
    <p class="textHeadline">{{ t('xp-messenger.dashboard.title') }}</p>

    <v-container class="mainViewContent">
      <!-- Partners List Card -->
      <v-card class="mb-4">
        <v-card-title class="d-flex justify-space-between align-center">
          <span>{{ t('xp-messenger.dashboard.partners') }}</span>
          <div class="d-flex align-center">
            <TertiaryButton
              class="mr-2"
              size="small"
              :loading="xpMessengerStore.loading"
              :disabled="xpMessengerStore.loading"
              prepend-icon="mdi-refresh"
              :text="''"
              @click="fetchPartners"
            />
            <TertiaryButton
              size="small"
              :prepend-icon="partnersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
              :text="''"
              @click="partnersExpanded = !partnersExpanded"
            />
          </div>
        </v-card-title>
        <v-expand-transition>
          <v-card-text v-show="partnersExpanded">
            <div v-if="xpMessengerStore.loading" class="text-center py-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">{{ t('xp-messenger.partners.loading') }}</p>
            </div>

            <v-alert
              v-else-if="xpMessengerStore.error"
              type="error"
              class="mb-4"
            >
              <strong>{{ t('xp-messenger.partners.error') }}:</strong> {{ xpMessengerStore.error }}
            </v-alert>

            <div v-else-if="xpMessengerStore.partners.length === 0" class="text-center py-4">
              <p>{{ t('xp-messenger.partners.noPartners') }}</p>
            </div>

            <template v-else>
              <div class="mb-4">
                <strong>{{ t('xp-messenger.partners.count') }}:</strong> {{ xpMessengerStore.partners.length }}
              </div>

              <v-table>
                <thead>
                  <tr>
                    <th>{{ t('xp-messenger.partners.backendId') }}</th>
                    <th>{{ t('xp-messenger.partners.name') }}</th>
                    <th>{{ t('xp-messenger.partners.id') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="partner in xpMessengerStore.partners" :key="partner.id">
                    <td>{{ partner.backendId }}</td>
                    <td>{{ partner.displayName }}</td>
                    <td>{{ partner.id }}</td>
                  </tr>
                </tbody>
              </v-table>
            </template>
          </v-card-text>
        </v-expand-transition>
      </v-card>

      <!-- Partner Registry Card -->
      <PartnerRegistry />
    </v-container>
  </v-container>
</template>

<script setup>
import { useXPMessengerStore } from '@/stores/xpMessengerStore';
import { inject, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import PartnerRegistry from '@/components/PartnerRegistry.vue';

const xpMessengerStore = useXPMessengerStore();
const $log = inject('log');
const { t } = useI18n();

const partnersExpanded = ref(true);

const fetchPartners = async () => {
  try {
    await xpMessengerStore.fetchPartners($log);
  } catch (error) {
    $log.error('Error fetching partners:', error);
  }
};

onMounted(async () => {
    await fetchPartners();
});
</script>

<style scoped>
.mainViewContent {
  margin-top: 16px;
}
</style>
